import axios from "axios"

export default function(data)
{
    var promise=new Promise((resolve,reject)=>{
        axios.post("headless.php?action=registerQuery&query="+data.query,data.params).then((code)=>{
            var es=new EventSource("headless.php?action=fetchQuery&id="+code.data);
            es.options=data;
            es.onmessage=function(event)
            {
                var d=JSON.parse(event.data);
                if (event.lastEventId==="0")
                {
                    this.stagecount=d.stagecount;
                }
                if (event.lastEventId==="-1")
                {
                    this.close();
                    if (this.options.fullresolve==1)
                        resolve(d);
                    else
                        resolve(d.data);
                    return;
                }
                if (d.stage!=null)
                    this.stage=d.stage;
                if (typeof(this.options.progress)=="function") 
                    this.options.progress(this.stagecount,this.stage,d);
            }
            es.onerror=function(event){
                this.close();
                reject(event);
            }
        });
    });
    return promise;
}